import {
  remToPx,
  is_Mobile
} from "../../common";

const hmbBtn = document.querySelector(".js-hmb-btn");
const menu = document.querySelector(".menu");
const header = document.querySelector("#header");
const overlay = document.querySelector(".menu-overlay")
let isHmbMenuOpen = false;

/**
 * ヘッダーメニューを開く処理を行います。
 */
const hmbMenuOpen = () => {
  hmbBtn.classList.add("active");
  menu.classList.add("open");
  header.classList.add("active");
  document.body.classList.add("active")
  isHmbMenuOpen = true;
  const mainIframes = document.querySelectorAll("main iframe");
  mainIframes.forEach((iframe) => {
    iframe.style.setProperty('pointer-events', 'none');
    iframe.style.setProperty('opacity', '0');
    iframe.style.setProperty('visibility', 'hidden');
  });
};

/**
 * ヘッダーメニューを閉じる処理を行います。
 */
const hmbMenuClose = () => {
  hmbBtn.classList.remove("active");
  menu.classList.remove("open");
  header.classList.remove("active");
  document.body.classList.remove("active")
  isHmbMenuOpen = false;
  const mainIframes = document.querySelectorAll("main iframe");
  mainIframes.forEach((iframe) => {
    iframe.style.setProperty('pointer-events', 'none', 'important');
    iframe.style.setProperty('opacity', '1', 'important');
    iframe.style.setProperty('visibility', 'visible', 'important');
  });
};

if (overlay) {
  overlay.addEventListener("click", () => {
    if (isHmbMenuOpen) {
      hmbMenuClose();
    }
  });
}

/**
 * ハンバーガー・検索メニューを初期化します。
 */
export const initHmbMenu = () => {
  if (!hmbBtn) return;
  //   if (!headerSearchBtn) return;

  hmbBtn.addEventListener("click", () => {
    if (isHmbMenuOpen) {
      hmbMenuClose();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const headerHeight = header.offsetHeight;
      if (headerHeight < scrollTop) {
        header.classList.remove("is-top");
      }
    } else {
      hmbMenuOpen();
    }
  });
  // アンカーリンククリック時にメニューを閉じる処理
  const anchorLinks = menu.querySelectorAll('a[href*="#"]');
  anchorLinks.forEach(link => {
    link.addEventListener('click', () => {
      hmbMenuClose();
    })
  })
};

export const menuAccordion = () => {
  const accordionTtl = document.querySelectorAll(".js-menu-item-ttl");
  const paddingTopRem = 1.5;
  const paddingBottomRem = 1;

  for (let i = 0; i < accordionTtl.length; i++) {
    accordionTtl[i].addEventListener("click", function () {
      if (is_Mobile() == "sp") {
        const panel = this.nextElementSibling;

        // クラスの追加と削除
        if (this.classList.contains("active")) {
          this.classList.remove("active");
          panel.classList.remove("active");
          panel.style.maxHeight = null;
          panel.style.paddingTop = "0";
          panel.style.paddingBottom = "0";
        } else {
          this.classList.add("active");
          panel.classList.add("active");
          panel.style.maxHeight =
            panel.scrollHeight +
            remToPx(paddingTopRem + paddingBottomRem) +
            "px";
          panel.style.paddingTop = paddingTopRem + "rem";
          panel.style.paddingBottom = paddingBottomRem + "rem";
        }
      }
    });
  }
};